import { ReactNode } from "react";
import "./CareWrap.css";
import { DocumentTitle } from "../../text/DocumentTitle/DocumentTitle";

interface CareWrapProps {
  children?: ReactNode | null;
}

export const CareWrap = ({ children }: CareWrapProps) => {
  return (
    <main className="care-wrap">
      <DocumentTitle title="Информация о составе и уходе за вещами" />
      <div className="care-wrap-content">{children}</div>
    </main>
  );
};
